module.exports = __webpack_public_path__ + "img/portugal-ill-defined-causes-male.85ec734f.png";